import { render, staticRenderFns } from "./EditOrderPaymentMethod.vue?vue&type=template&id=83272bb6&"
import script from "./EditOrderPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./EditOrderPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports